import React from 'react';
import { MessageCircle } from 'lucide-react';

const WHATSAPP_URL = "https://wa.me/919850206906?text=Hi%2C%20I%20have%20a%20question%20about%20the%20free%20webinar%20on%20May%203.";

const WhatsAppButton: React.FC = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="hidden md:flex fixed bottom-6 right-4 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] rounded-full items-center justify-center shadow-lg shadow-[#25D366]/30 transition-transform hover:scale-110"
    >
      <MessageCircle className="w-7 h-7 text-white fill-white" />
    </a>
  );
};

export default WhatsAppButton;
